export default __webpack_public_path__ + "static/media/experts2.f4b1b25a.png";